import { useQuery } from '@tanstack/react-query';
import { useAccountApi } from '../../hooks/use-settings-api';

export const QK_TWO_FACTOR_QR_CODE = ['two-factor-qr-code'] as const;

export function useTwoFactorQrCode(enabled: boolean) {
  const { accountApi } = useAccountApi();

  return useQuery({
    queryKey: QK_TWO_FACTOR_QR_CODE,
    queryFn: () => accountApi.twoFactorQrCode(),
    enabled,
  });
}
